<template>
  <va-modal
    :value="showModal"
    ref="changeAudProviderModal"
    :okText="$t('modals.defaults.button_save')"
    :cancelText="$t('modal.cancel')"
    @cancel="closeAudProviderModal"
    @ok="changeProvider()"
    :okDisabled="isSubmiting || disabled || !selectedAudProvider"
  >
    <div slot="header" class="d-flex justify--space-between">
      <span class="modal-title">{{ $t('entities.inputs.aud_provider') }}</span>
    </div>

    <div v-if="isLoading">
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-else class="evollu-form mb-5">
      <div class="row">
        <div class="col-12">
          <va-notification v-if="disabled" color="danger">
            <va-badge color="danger">
              {{ $t('users.errors.title') }}
            </va-badge>
            <span v-if="selectedLeads == 0"> {{$t('leads.aud_provider.no_selected_leads')}}</span>
            <span v-else-if="selectedLeads > 100">{{$t('leads.aud_provider.too_many_leads')}}</span>
            <span v-else>{{$t('leads.aud_provider.one_page')}}</span>
          </va-notification>

          <va-notification v-else color="success">
            <va-badge color="info">
              {{ $t('users.errors.title') }}
            </va-badge>
            <span>{{ $t('leads.aud_provider.selected_leads', {count: allowedLeadsCount}, allowedLeadsCount) }}</span>
          </va-notification>
        </div>
      </div>

      <div class="row mb-5">
        <div class="col-12">
          <label class="form-label">{{$t('entities.inputs.aud_provider')}}:</label>
          <multiselect
            :options="availableAudProviders"
            v-model="selectedAudProvider"
            placeholder="---"
            track-by="id"
            label="name"
            select-label=""
            selected-label=""
            deselect-label=""
            :disabled="disabled"
            :allow-empty="false"
            :multiple="false"
            :searchable="true">
            <span slot="noResult">{{ 'patients.noResults'| translate }}</span>
          </multiselect>
        </div>
      </div>
    </div>
  </va-modal>
</template>
<script>
import { mapGetters } from 'vuex'
import LoadingAnimation from '@/components/common/loaders/Loading'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    LoadingAnimation,
    Multiselect,
  },
  props: {
    hasLeadsSelected: {
      type: Boolean,
      required: true
    },
    selectedLeads: {
      type: Number,
      required: true
    },
    nrOfFilters: {
      type: Number,
      required: true
    },
    pages: {
      type: Number,
      required: true
    },
    currentDisplayedLeads: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      isLoading: false,
      isSubmiting: false,
      selectedAudProvider: null
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    closeAudProviderModal: function () {
      this.$emit('closeAudProviderModal')
      setTimeout(() => {
        this.showModal = false
      }, 250)
    },
    changeProvider: function () {
      if (this.allowedLeads.length !== this.allowedLeadsCount) {
        console.log('error')
        return
      }
      // do stuff
      this.$http({
        url: `${this.$store.state.evollead_server}/leads-aud-provider/batch-update`,
        method: 'POST',
        data: { new_provider: this.selectedAudProvider.id, leads: this.allowedLeads.map(lead => lead.id) }
      }).then((response) => {
        this.showToast(this.$t('leads.aud_provider.success'), this.$store.state.successToastOptions)
        this.$emit('audProviderWasUpdated')
        this.closeAudProviderModal()
      }).catch((error) => {
        console.log(error.response)
        this.showToast(this.$t('leads.aud_provider.error'), this.$store.state.errorToastOptions)
        this.closeAudProviderModal()
      })
    }
  },
  computed: {
    ...mapGetters([
      'availableAudProviders'
    ]),
    disabled: function () {
      return (this.pages > 1 && !this.hasLeadsSelected) || this.selectedLeads === 0 || this.selectedLeads > 100
    },
    allowedLeads: function (){
      return this.currentDisplayedLeads.filter(lead => lead.to_partner !== false)
    },
    allowedLeadsCount: function (){
      return this.allowedLeads.length
    }

  }
}
</script>

<style lang="scss">
.alert-success {
  background-color: #95e2d5;
  box-shadow: 0px 4px 9.6px 0.4px rgba(28, 133, 114, 0.5);
}
</style>
